<template>
  <div class="row" style="padding: 0px 20px 0 20px">
    <div class="col-sm-3 customer-edit-info">
      <!-- Photo and Info -->
      <div class="row" style="margin-bottom: 30px">
        <div class="col-sm-4">
          <div class="customer-photo" :style="{
            'background-image': 'url(' + customer.photo + ')',
            transform: `rotate(${customer.photo_rotate}deg)`,
          }"></div>
        </div>
        <div class="col-sm-8 d-flex flex-column align-items-start justify-content-center" style="padding-left: 25px">
          <small class="customer-import-code" v-if="customer.import_code && customer.import_code != ''">{{
            customer.import_code }}</small>
          <h2 class="customer-name">{{ customer.full_name }}</h2>
          <h3 v-if="customer_has_birth" class="customer-name-data">
            {{ customer_birth_date }} -
            <strong>{{ customer_age }} años</strong>
          </h3>
          <h3 class="customer-name-data">
            ID Paciente -
            <strong>{{ customer.history_number }}</strong>
          </h3>
          <div v-if="external_app_protocols" class="d-flex" style="gap:10px">
            <a :href="getCustomerExternalURL(idx, customer)" v-for="(name, idx) in external_app_protocols" :index="idx"
              class="btn btn-wabident-round small">{{ name
              }}</a>
          </div>
          <small v-if="external_app_protocols">
            <a class="btn-link" href="/wabiconnector_setup.exe">Descarga conector para Windows</a>
          </small>
        </div>
      </div>

      <!-- Datapoint: History -->
      <div class="customer-notes row mb-2">
        <div class="col py-2">
          <label>Información importante</label>
          <div class="customer-history-itsection" v-for="(section, sectionkey) in customer_important_info"
            :key="sectionkey">
            <legend>{{ sectionkey }}</legend>
            <div class="d-flex flex-wrap">
              <div v-for="(history, historykey) in section" :key="historykey" class="customer-history-item">
                <img v-if="history.icon" :src="history.icon" :alt="history.label" />
                {{ history.label }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <template v-if="is_core">
        <div class="form-check form-check-inline mb-2">
          <input class="form-check-input" type="checkbox" v-model="show" id="notas" />
          <label class="form-check-label" for="notas">Mostrar Notas</label>
        </div>

        <template v-if="show">
          <div class="customer-notes row mb-2">
            <div class="col">
              <label>Notas</label>
              <p>{{ customer.notes }}</p>
            </div>
          </div>
        </template>
      </template>

      <template v-else>
        <div class="customer-notes row mb-2">
          <div class="col">
            <label>Notas</label>
            <p>{{ customer.notes }}</p>
          </div>
        </div>
      </template>


      <!-- Datapoint: Custom Fields -->
      <div v-for="field, index in customer_custom_fields" :key="index" class="customer-datapoint row">
        <div class="col">
          <label>{{ field.name }}</label>
          <p>{{ customer.custom_fields[field.id] }}</p>
        </div>
      </div>

      <!-- Datapoint: Clinic -->
      <div class="customer-datapoint row">
        <div class="col">
          <label>Clínica de Referencia</label>
          <p>{{ showClinic(customer) }}</p>
        </div>
      </div>

      <!-- Datapoint: Clinic -->
      <div class="customer-datapoint row">
        <div class="col">
          <label>Doctor/a de Referencia</label>
          <p>{{ showDoctor(customer) }}</p>
        </div>
      </div>

      <!-- Child Info -->
      <template v-if="!is_adult">
        <div class="customer-datapoint row">
          <div class="col">
            <label>Adulto a cargo</label>
            <p>{{ adult_type }} - {{ customer.adult_name }}</p>
          </div>
        </div>
      </template>

      <!-- Datapoint: Phone -->
      <div class="customer-datapoint row">
        <div class="col">
          <label>Teléfono de contacto</label>
          <p>{{ customer.phone }}</p>
        </div>
      </div>

      <!-- Datapoint: Email -->
      <div class="customer-datapoint row">
        <div class="col">
          <label>Email de de contato</label>
          <p>{{ customer.email }}</p>
        </div>
      </div>

      <!-- Datapoint: NIF -->
      <div class="customer-datapoint row">
        <div class="col">
          <label>DNI/Pasaporte</label>
          <p>{{ customer.nif }}</p>
        </div>
      </div>

      <!-- Datapoint: Address -->
      <div class="customer-datapoint row">
        <div class="col">
          <label>Dirección</label>
          <p>
            {{ customer.address }}, {{ customer.zipcode }}, {{ customer.city }}
          </p>
        </div>
      </div>

      <!-- Datapoint: Address -->
      <div class="customer-datapoint row">
        <div class="col">
          <label>Ley de protección de datos:</label>
          <p class="customer-consent" :class="{ signed: customer.is_consent_signed }">
            <span v-if="
              customer.is_consent_signed &&
              customer.is_consent_signed != 'false'
            ">FIRMADA</span>
            <span v-else>SIN FIRMAR</span>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col text-center my-3">
          <button @click="tab_index = 0" :disabled="tab_index == 0" type="button" class="btn btn-wabident-round big">
            Editar ficha cliente
          </button>
        </div>
      </div>
    </div>
    <div class="col-sm-9">
      <b-tabs v-model="tab_index" justified lazy>
        <b-tab key="edit" title="Datos" :active="customerInitialTab() == 'edit'">
          <customer-edit-data @customerUpdated="customerUpdated" :customer="customer"></customer-edit-data>
        </b-tab>

        <b-tab key="appointments" title="Citas" :active="customerInitialTab() == 'appointments'">
          <customer-edit-appointments :customer="customer"></customer-edit-appointments>
        </b-tab>

        <b-tab key="history" title="Anamnésis" :active="customerInitialTab() == 'history'">
          <customer-edit-history @historyUpdated="historyUpdated" :customer="customer"></customer-edit-history>
        </b-tab>

        <b-tab v-if="enable_customer_dot" key="dot" title="DOT" :active="customerInitialTab() == 'dot'">
          <customer-edit-dot :customer="customer"></customer-edit-dot>
        </b-tab>

        <b-tab key="quotations" title="Planes" :active="customerInitialTab() == 'quotations'">
          <customer-edit-quotations @quotationsUpdated="quotationsUpdated"
            :customer="customer"></customer-edit-quotations>
        </b-tab>

        <b-tab v-if="enable_customer_odontogram" key="odontogram" title="Odontograma"
          :active="customerInitialTab() == 'odontogram'">
          <customer-odontogram :customer="customer"></customer-odontogram>
        </b-tab>

        <b-tab v-if="new_treatments" key="timeline" title="Historial" :active="customerInitialTab() == 'timeline'">
          <customer-timeline :customer="customer"></customer-timeline>
        </b-tab>

        <b-tab key="invoices" :title="invoices_title" :active="customerInitialTab() == 'invoices'">
          <customer-invoices :customer="customer"></customer-invoices>
        </b-tab>

        <b-tab key="documents" title="Documentos" :active="customerInitialTab() == 'documents'">
          <customer-documents :customer="customer"></customer-documents>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      customer: {},
      tab_index: 0,
      show: false,
      history_items: {
        penicillin: {
          text: "Alergia a la penicilina",
          icon: "/images/penicilina.svg",
        },
        latex: {
          text: "Alergia al látex",
          icon: "/images/latex.svg",
        },
        hepatitis: {
          text: "Hepatitis",
          icon: "/images/hepatitis.svg",
        },
        diabetes: {
          text: "Diabetes",
          icon: "/images/diabetes.svg",
        },
        heart_condition: {
          text: "Problemas cardíacos",
          icon: "/images/cardiacos.svg",
        },
        hiv: {
          text: "VIH",
          icon: "/images/vih.svg",
        },
        anticoagulants: {
          text: "Anticoagulantes",
        },
        inmunosuppressants: {
          text: "Inmunosupresores",
        },
        headache: {
          text: "Cefáleas",
        },
        neuralgia: {
          text: "Neuralgia",
        },
        bruxism: {
          text: "Bruxismo",
        },
        tobacco: {
          text: "Tabaco",
        },
        drugs: {
          text: "Drogas",
        },
        herpes: {
          text: "Herpes",
        },
        hypertension: {
          text: "Hipertensión",
        },
        autoinmune: {
          text: "Enf. autoinmune",
        },
      },
    };
  },
  props: {
    initCustomer: { required: true },
    clinicId: { required: true },
  },
  computed: {
    external_app_protocols() {
      if (!this.clinic || !this.clinic.config) {
        return null;
      }

      return this.clinic.config.external_app_protocols || null;
    },
    customer_custom_fields() {
      let ret = [];

      if (this.clinic && this.clinic.config) {
        const cfg = this.clinic.config.customer_custom_fields_config;
        if (!cfg) {
          return ret;
        }

        Object.keys(cfg).forEach((key) => {
          const value = cfg[key];
          if (!value.important) {
            return;
          }

          ret.push({
            id: key,
            name: value.name,
            desc: value.desc,
            type: value.type,
            width: value.width,
            order: value.order,
            important: value.important,
          });
        });
      }

      ret.sort((a, b) => {
        return a.order - b.order;
      });

      return ret;
    },

    doctor_dict() {
      let ret = {};
      if (this.clinic && this.clinic.doctors) {
        this.clinic.doctors.forEach((d) => {
          ret[d.doctor.id] = d.name;
        });
      }
      return ret;
    },
    invoices_title() {
      const can_invoice = this.clinic && !this.clinic.config.disable_invoices;
      return can_invoice ? 'Facturación' : 'Pagos';
    },
    enable_customer_dot() {
      return this.clinic && this.clinic.config["enable_customer_dot"];
    },
    enable_customer_odontogram() {
      return this.clinic && this.clinic.type == 'dental' && this.clinic.config["enable_customer_odontogram"];
    },
    new_treatments() {
      return this.clinic && this.clinic.config["enable_timeline"];
    },
    custom_history_enabled() {
      return this.clinic && this.clinic.config["custom_customer_history"];
    },
    customer_important_info() {
      let ret = {};
      if (this.custom_history_enabled) {
        // Alergias Medicamentos
        if (
          this.customer.history &&
          this.customer.history.allergies &&
          this.customer.history.allergies.medicines
        ) {
          ret["Alerg. Medicamentos"] = [
            {
              label: this.customer.history.allergies.other_medicines,
            },
          ];
        }

        // Alergias Substancias
        if (
          this.customer.history &&
          this.customer.history.allergies &&
          this.customer.history.allergies.substances
        ) {
          ret["Alerg. Sustancias"] = [
            {
              label: this.customer.history.allergies.other_substances,
            },
          ];
        }

        // Enfermedades
        if (this.customer.history && this.customer.history.diseases) {
          let section_data = [];

          const section_name = "Enfermedades";
          const customer_history_section = this.customer.history.diseases;

          for (const history_item_slug in this.history_items) {
            const history_item = this.history_items[history_item_slug];
            const customer_history_value =
              customer_history_section[history_item_slug] || null;

            if (history_item && customer_history_value) {
              section_data.push({
                label: history_item.text,
                icon: history_item.icon,
              });
            }
          }

          if (this.customer.history.diseases.other_diseases) {
            section_data.push({
              label: this.customer.history.diseases.other_diseases_content,
            });
          }

          if (section_data.length) {
            ret[section_name] = section_data;
          }
        }

        // Medicinas
        if (
          this.customer.history &&
          this.customer.history.medicines &&
          this.customer.history.medicines.other_medicines
        ) {
          let r = this.customer.history.medicines.other_medicines_content;
          if (r) {
            ret["Medicamentos"] = [
              {
                label: r,
              },
            ];
          }
        }

        // Cirugías Previas
        if (
          this.customer.history &&
          this.customer.history.background &&
          this.customer.history.background.surgical_interventions
        ) {
          let r =
            this.customer.history.background.surgical_interventions_content;
          if (r) {
            ret["Cirugías Previas"] = [
              {
                label: r,
              },
            ];
          }
        }

        // Tratamientos Previos
        if (
          this.customer.history &&
          this.customer.history.background &&
          this.customer.history.background.previous_treatments
        ) {
          let r = this.customer.history.background.previous_treatments_content;
          if (r) {
            ret["Ttos. Previos"] = [
              {
                label: r,
              },
            ];
          }
        }
      } else {
        const sections = {
          allergies: "Alergias",
          diseases: "Enfermedades",
          medicines: "Medicamentos",
          background: "Antecedentes",
          habits: "Habitos",
        };

        if (!this.customer.history) {
          return;
        }

        for (const section_slug in sections) {
          const section_name = sections[section_slug];
          let section_data = [];

          const customer_history_section = this.customer.history[section_slug];
          if (!WabiDent.isObject(customer_history_section)) {
            continue;
          }

          for (const history_item_slug in this.history_items) {
            const history_item = this.history_items[history_item_slug];
            const customer_history_value =
              customer_history_section[history_item_slug] || null;

            if (history_item && customer_history_value) {
              section_data.push({
                label: history_item.text,
                icon: history_item.icon,
              });
            }
          }

          let others = customer_history_section["others"];
          if (Array.isArray(others)) {
            others.forEach((other) => {
              section_data.push({
                label: other,
              });
            });
          }

          if (section_data.length) {
            ret[section_name] = section_data;
          }
        }
      }
      return ret;
    },
    is_dental() {
      if (!this.clinic) return false;
      if (!this.clinic.type) return false;
      if (this.clinic.type == "dental") return true;
      return false;
    },
    treatments_title() {
      return this.is_dental ? "Odontograma" : "Tratamientos";
    },
    customer_has_birth() {
      return (
        this.customer &&
        this.customer.birth_date !== null &&
        this.customer.birth_date !== ""
      );
    },
    customer_birth_date() {
      return moment(this.customer.birth_date).toDate().toLocaleDateString();
    },
    customer_age() {
      if (!this.customer_has_birth) {
        return 0;
      }

      let birth = moment(this.customer.birth_date);
      let now = moment();
      return now.diff(birth, "years");
    },
    is_adult() {
      return this.customer_age >= 12;
    },
    adult_type() {
      return WabiDent.AdultType[this.customer.adult_type];
    },
    ...mapGetters(["clinic", "is_core"]),
  },
  methods: {
    getCustomerExternalURL(idx, customer) {

      const params = new URLSearchParams({
        id: customer.history_number,
        firstName: customer.name,
        lastName: customer.surname,
        birthDate: moment(customer.birth_date).format('MM-DD-YYYY'),
        gender: customer.sex == 'male' ? 0 : 1,
      });


      return `wabident://${idx}/${customer.history_number}?` + params.toString();
    },
    customerInitialTab() {
      if (!this.clinic) return null;
      if (!this.clinic.config) return null;
      return this.clinic.config.customer_initial_tab || null;
    },
    showClinic(customer) {
      if (!this.clinic) return "";
      return this.clinic.clinic_names[customer.clinic_id] || "";
    },
    showDoctor(customer) {
      if (!this.clinic) return '';
      return this.doctor_dict[customer.doctor_id] || 'Sin Asignar';
    },
    customerUpdated(customer) {
      this.customer = JSON.parse(JSON.stringify(customer));
    },
    historyUpdated(history) {
      this.customer.history = JSON.parse(JSON.stringify(history));
    },
    treatmentsUpdated(treatments) {
      this.customer.treatments = JSON.parse(JSON.stringify(treatments));
    },
    quotationsUpdated(quotations) {
      this.customer.treatments = JSON.parse(JSON.stringify(quotations));
    },
    loadClinicData() {
      if (!this.clinic) {
        axios
          .get("/agenda/clinic_info", {
            params: {
              clinic_id: this.clinicId,
            },
          })
          .then((response) => {
            let data = response.data;
            if (data.error) {
              console.log("[ERR] loadClinicData:", data.error);
            } else {
              this.setClinic(data);
            }
          })
          .catch((error) => {
            console.log("[ERR] loadClinicData:", error);
          });
      }
    },
    ...mapMutations(["setClinic"]),
  },
  created() {
    this.customer = JSON.parse(JSON.stringify(this.initCustomer));
    if (!this.customer.custom_fields || Array.isArray(this.customer.custom_fields)) {
      this.customer.custom_fields = {};
    }
  },
  mounted() {
    document.title = 'Pac. ' + this.customer.full_name;
    this.loadClinicData();
  },
};
</script>

<style lang="scss" scoped>
.customer-edit-info {
  .customer-photo {
    background-color: var(--theme-grey);
    max-width: 150px;
    width: 100%;
    aspect-ratio: 1;
    border-radius: 50%;
    background-position: center center;
    background-size: cover;
  }

  .customer-name {
    font-size: 18px;
    color: black;
    font-weight: 500;
    letter-spacing: 0.36px;
    text-transform: uppercase;
    margin-bottom: 15px;
  }

  .customer-import-code {
    font-size: 8px;
    font-family: monospace;
    color: var(--theme-grey);
  }

  .customer-name-data {
    font-size: 15px;
    color: var(--theme-line-color);
    letter-spacing: 0.3px;
  }

  .customer-datapoint,
  .customer-notes {
    label {
      color: var(--theme-line-color);
      font-weight: 500;
      font-size: 14px;
    }

    p {
      color: var(--theme-text-color);
      font-size: 16px;
      line-height: 1.25;
    }

    .customer-history-itsection {
      legend {
        color: var(--theme-color-absent);
        font-size: 14px;
        font-weight: 600;
        margin: 0;
      }
    }

    .customer-history-item {
      font-weight: 400;
      font-size: 12px;
      color: var(--theme-color-absent);
      margin: 5px;

      img {
        width: 20px;
        height: 20px;
        object-fit: contain;
        vertical-align: middle;
        color: var(--theme-color-absent);
        fill: currentColor;
      }
    }
  }

  .customer-notes+.customer-notes {
    margin-top: 12px;
  }

  .customer-notes {
    background-color: var(--theme-grey-bg);
  }

  .customer-consent {
    color: var(--theme-color-absent);

    &.signed {
      color: var(--theme-text-color);
    }
  }
}
</style>
